module.exports = __webpack_public_path__ + "static/media/loading-ring.299c42cd.svg";